/**
 * Created by Ning Jiang on 3/6/2019.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {TombOfNefertitiSpinEvent} from "../../spin/TombOfNefertitiSpinController";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class TombOfNefertitiInitialWPView extends BaseView {

    private _layer:ScalableLayer;
    private _textItem:PIXI.Text;
    private _winningItems:TimelineSprite[] = [];
    private _extinguishItems:TimelineSprite[] = [];

    private _stickySymbols:boolean[];
    private _isShowingWinText:boolean = false;

    set stickySymbols(value:boolean[]) {
        this._stickySymbols = value;
    }

    constructor() {
        super();
        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    public showTotalReSpinText(): void {
        if (!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
            this._isShowingWinText = true;
            TweenLite.to(this._textItem, 0.25, {alpha: 1});
        }
    }

    public hideTotalReSpinText():void {
        TweenLite.killTweensOf(this._textItem);
        if(this._isShowingWinText) {
            this._isShowingWinText = false;
            this._textItem.alpha = 1;
        }
        TweenLite.to(this._textItem, 0.25, {alpha : 0});
    }

    public showTotalReSpin(amount:number):void {
        this._textItem.visible = true;

        TweenLite.fromTo(this._textItem, 0.3, {
            alpha : 0
        }, {
            alpha : 1,
            onComplete : () => {
                TweenLite.to(() => {}, 0.5, {
                    onComplete : () => {
                        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiSpinEvent.RESET_SHOW_RESPIN_FLAG));
                    }
                });
            }
        });
    }

    public playFireOnWinningSymbols(i:number):void {
        if(this._stickySymbols[i]) {
            this._winningItems[2 * i].visible = true;
            this._winningItems[2 * i + 1].visible = true;
            this._winningItems[2 * i].playLoop();
            this._winningItems[2 * i + 1].playLoop();
        }
    }

    public stopAll():void {
        for(let i:number = 0; i < this._stickySymbols.length; ++i) {
            if(this._winningItems[2 * i].worldVisible) {
                const numOfExtinguishItems:number = 3;

                this._winningItems[2 * i].stopLoop();
                this._winningItems[2 * i + 1].stopLoop();
                this._winningItems[2 * i].visible = false;
                this._winningItems[2 * i + 1].visible = false;

                this._extinguishItems[i * numOfExtinguishItems].getAnimationAutoShowHide(true, true);
                this._extinguishItems[(i * numOfExtinguishItems) + 1].getAnimationAutoShowHide(true, true);
                this._extinguishItems[(i * numOfExtinguishItems) + 2].getAnimationAutoShowHide(true, true);
            }
        }
    }

    protected initAnimations():void {
        const textStyle:TextStyleOptions = {
                fill : ["#F3B23D", "#FDFE54", "#EF8A34"],
                fillGradientStops : [0.1, 0.5, 0.7],
                fillGradientType : 0,
                fontSize : 80,
                fontFamily : TombOfNefertitiGameConfig.instance.USABLE_FONT,
                dropShadow : true,
                dropShadowAlpha : 1,
                dropShadowAngle : 90,
                dropShadowBlur : 6,
                dropShadowColor : "#000000",
                dropShadowDistance : 5,
                padding : 8,
                stroke : "#3654B8",
                strokeThickness : 6
            },
            textItem:PIXI.Text = new PIXI.Text(Translation.translate("TOTAL WIN"), textStyle),
            centrePos:number[] = Helper.getSymbolPositions(Math.floor(TombOfNefertitiGameConfig.instance.REELS_NUM / 2), 0),
            offsetY:number = 50;

        textItem.anchor.set(0.5);
        textItem.alpha = 0;
        textItem.position.set(centrePos[0], centrePos[1] - offsetY);

        this._layer.addChild(textItem);
        this._textItem = textItem;

        this.createFireOnWinningSymbols();
    }

    private createFireOnWinningSymbols():void {
        const numOfItems:number = TombOfNefertitiGameConfig.instance.REELS_NUM,
            numOfExtinguishItems:number = 3,
            layer:PIXI.Container = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.YELLOW_FIRE.name);

        let item:TimelineSprite,
            colorItem:TimelineSprite,
            extinguishItem:TimelineSprite,
            pos:number[];

        for(let i:number = 0; i < numOfItems; ++i) {
            item = new TimelineSprite(GameResources.getTextures('fireLoopInnerWhite'));
            colorItem = new TimelineSprite(GameResources.getTextures('fireLoopGreyScale'));
            item.blendMode = PIXI.BLEND_MODES.ADD;
            item.anchor.set(0.5);
            item.visible = false;

            colorItem.blendMode = PIXI.BLEND_MODES.ADD;
            colorItem.anchor.set(0.5);
            colorItem.visible = false;
            colorItem.tint = 0xFFF200;

            pos = Helper.getSymbolPositions(i, 0);

            item.position.set(pos[0], pos[1]);
            colorItem.position.set(pos[0], pos[1]);
            this._winningItems.push(item);
            this._winningItems.push(colorItem);
            layer.addChild(item);
            layer.addChild(colorItem);

            for(let j:number = 0; j < numOfExtinguishItems; ++j) {
                extinguishItem = new TimelineSprite(GameResources.getTextures("fireExtinguish"));
                extinguishItem.blendMode = PIXI.BLEND_MODES.ADD;
                extinguishItem.anchor.set(0.5);
                extinguishItem.scale.set(1.2);
                extinguishItem.visible = false;

                extinguishItem.position.set(pos[0], pos[1]);
                this._extinguishItems.push(extinguishItem);
                layer.addChild(extinguishItem);
            }
        }
    }
}